<template>
  <page>
    <template slot='content'>
      <os-list-movimentacao></os-list-movimentacao>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsListMovimentacao from '@/components/Borracharia/OsListMovimentacao'

export default {
  components: {
    Page,
    OsListMovimentacao,
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created () {
    const dsColaborador = this.$store.getters['filial/filial']
    this.$store.dispatch('filial/actionSidebar')
  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens para atendimento',
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {
    reloadPage() {
      const host = window.location.pathname;

      this.timer = setTimeout(() => {
        if (host == "/" || host == "/osPreventiva") {
          this.$store.dispatch("os/fetchFromApi", {});
        } else if (host == '/osExterna') {
          this.$store.dispatch('os/fetchFromApiExterna')
        }
        this.reloadPage();
      }, 1000 * 5);
      console.log(this.timer)

    }
  }
}
</script>
